import React, { useState } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import './HotelDetails.css';

function HotelDetails({ hotel, hotelDetails, availability, onClose, loading }) {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [nights, setNights] = useState(1);

  // Calculate availability stats
  const calculateStats = () => {
    if (!availability) return { stdRoomPercent: 0, minValue: 0, maxValue: 0 };
    
    const totalDays = new Set(availability.map(day => day.avail_date)).size;
    const stdRoomDays = new Set(availability.filter(day => 
      day.rate_plan === "Std Room" || day.rate_plan === "Std Suite"
    ).map(day => day.avail_date)).size;

    const values = availability
      .filter(day => day.point_value !== 'N/A')
      .map(day => parseFloat(day.point_value));

    return {
      stdRoomPercent: Math.round((stdRoomDays / totalDays) * 100),
      minValue: Math.min(...values),
      maxValue: Math.max(...values)
    };
  };

  const { stdRoomPercent, minValue, maxValue } = calculateStats();

  // Group rooms by date and get best rates
  const availabilityMap = availability ? availability.reduce((acc, day) => {
    if (!acc[day.avail_date]) {
      acc[day.avail_date] = [];
    }
    acc[day.avail_date].push({
      price: day.pay_rate_usd,
      points: day.points_rate,
      pointValue: day.point_value,
      roomsAvail: day.rooms_avail,
      resLink: day.res_link,
      roomType: day.room_type,
      ratePlan: day.rate_plan
    });
    return acc;
  }, {}) : {};

  const tileContent = ({ date }) => {
    const dateStr = date.toISOString().split('T')[0];
    const rooms = availabilityMap[dateStr];
    
    if (!rooms || rooms.length === 0) return null;

    // Color coding based on rate plan
    const getRoomTypeClass = (ratePlan) => {
      switch (ratePlan) {
        case 'Std Room': return 'bg-primary';
        case 'Club Room': return 'bg-orange';
        case 'Std Suite': return 'bg-purple';
        case 'Premium Suite': return 'bg-black';
        default: return '';
      }
    };

    // Find best rates for the date
    const bestRates = rooms.reduce((best, room) => {
      if (room.pointValue !== 'N/A' && (!best.pointValue || parseFloat(room.pointValue) > parseFloat(best.pointValue))) {
        best.pointValue = room.pointValue;
      }
      if (room.points !== '-' && (!best.points || parseInt(room.points) < parseInt(best.points))) {
        best.points = room.points;
      }
      return best;
    }, { pointValue: null, points: null });

    return (
      <div className="tile-content">
        <div className={`room-type ${getRoomTypeClass(rooms[0].ratePlan)}`}>
          <div className="price">{rooms[0].price}</div>
          <div className="points">{bestRates.points || 'N/A'}</div>
          <div className="value">{bestRates.pointValue ? `${bestRates.pointValue}¢` : '-'}</div>
          <div className="rooms">({rooms[0].roomsAvail})</div>
        </div>
      </div>
    );
  };

  return (
    <div className="modal hotel-details-modal">
      <div className="modal-content">
        <div className="modal-header">
          <button className="close" onClick={onClose}>&times;</button>
        </div>
        
        {loading ? (
          <div className="text-center py-5">
            <div className="spinner-border text-primary">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-2">Loading availability data...</p>
          </div>
        ) : (
          <div className="row">
            <div className="col-12">
              <p>
                <a href={hotel.hotelLink} target="_blank" rel="noopener noreferrer">
                  <span className="text-primary fs-5">{hotel.name}</span>
                </a>
                {/* <button className="btn btn-primary ms-2">
                  Setup Alert <i className="fas fa-bell"></i>
                </button> */}
              </p>

              <h6 className="text-primary">
                <i className="fas fa-calendar-alt"></i> {stdRoomPercent}% Standard Redemption Available
                <i className="fas fa-hand-holding-usd ms-3"></i> {minValue.toFixed(1)} ~ {maxValue.toFixed(1)}¢
              </h6>

              <h6 className="calendar-legend">
                <span className="bg-primary text-white">Standard Room</span>
                <span className="bg-orange text-white">Club Room</span>
                <span className="bg-purple text-white">Standard Suite</span>
                <span className="bg-black text-white">Premium Suite</span>
              </h6>

              <h6><span className="text-primary">(n)</span>: Number of rooms available</h6>

              <div className="stay-selector">
                <span>Stay of </span>
                <select 
                  className="form-select d-inline w-auto"
                  value={nights}
                  onChange={(e) => setNights(parseInt(e.target.value))}
                >
                  {[1,2,3,4,5].map(n => (
                    <option key={n} value={n}>{n}</option>
                  ))}
                </select>
                <span> night(s)</span>
              </div>

              <div className="calendar-section">
                <Calendar 
                  onChange={setSelectedDate}
                  value={selectedDate}
                  tileContent={tileContent}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default HotelDetails; 